import { useDispatch } from 'react-redux'
import { PartialUpdateBoothSpaceOrganizerRequest } from 'types/swagger'
import { useSpaceParams } from 'hooks'
import { saveBooth } from '../actions'

export default () => {
    const dispatch = useDispatch()
    const { eventSlug, spaceSlug } = useSpaceParams()
    return (booth: PartialUpdateBoothSpaceOrganizerRequest) => dispatch(saveBooth({
        data: booth,
        eventSlug,
        boothSlug: spaceSlug,
    }))
}
